module.exports = __webpack_public_path__ + "static/media/11.7b6b25c2.JPG";